/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBaseline = createReactComponent("baseline", "IconBaseline", [
  ["path", { d: "M4 20h16", key: "svg-0" }],
  ["path", { d: "M8 16v-8a4 4 0 1 1 8 0v8", key: "svg-1" }],
  ["path", { d: "M8 10h8", key: "svg-2" }]
]);

export { IconBaseline as default };
//# sourceMappingURL=IconBaseline.js.map
